"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectExtendedResponseModelTargetAudience = void 0;
exports.ProjectExtendedResponseModelTargetAudience = {
    Children: "children",
    YoungAdult: "young adult",
    Adult: "adult",
    AllAges: "all ages",
};
